<template>
  <div
    class="relative h-10 w-10 flex-none cursor-pointer text-center"
    @click="openProfile"
  >
    <transition v-if="!loadedFromCache" name="opacity">
      <img
        v-if="pictureUrl"
        draggable="false"
        alt="Profile Picture"
        class="h-full w-full rounded-full border object-cover shadow-inner"
        :src="pictureUrl"
      />
      <div
        v-else
        class="h-full w-full rounded-full bg-linear-to-br from-orange to-pink shadow"
      ></div>
    </transition>
    <template v-else>
      <img
        v-if="pictureUrl"
        draggable="false"
        alt="Profile Picture"
        class="h-full w-full rounded-full border object-cover shadow-inner"
        :src="pictureUrl"
      />
      <div
        v-else
        class="h-full w-full rounded-full bg-linear-to-br from-orange to-pink shadow"
      ></div>
    </template>
  </div>
</template>
<script>
import { useGroupsStore } from "@/stores/modules/groups/groups";
import { useUserStore } from "@/stores/modules/user/user";
import { useMemberProfile } from "@/composables/useMemberProfile";
import { ImageSizes } from "@/enums/images-sizes";
import { getObjectPathValue } from "@/helpers/utils/ObjectPath";

export default {
  name: "TinyUserThumb",
  props: {
    uuid: {
      type: String,
      default: "",
    },
    groupId: {
      type: String,
      default: "",
    },
  },
  setup() {
    const groupsStore = useGroupsStore();
    const userStore = useUserStore();
    const { openMemberProfile } = useMemberProfile();
    return { groupsStore, userStore, openMemberProfile };
  },
  data() {
    return {
      THUMB: ImageSizes.Thumb,
    };
  },
  computed: {
    membersProfilePicturesData() {
      return this.groupsStore.groupMembersProfilePictureData;
    },
    activeGroupId() {
      return this.userStore.activeGroup;
    },
    targetGroupId() {
      return this.groupId || this.userStore.activeGroup;
    },
    pictureUrl() {
      return getObjectPathValue(this.membersProfilePicturesData, [
        this.targetGroupId,
        this.uuid,
        this.THUMB,
        "url",
      ]);
    },
    loadedFromCache() {
      return (
        getObjectPathValue(this.membersProfilePicturesData, [
          this.targetGroupId,
          this.uuid,
          this.THUMB,
          "fromCache",
        ]) ?? false
      );
    },
  },
  watch: {
    uuid: {
      immediate: true,
      handler(newUuid) {
        if (newUuid) {
          this.fetchProfilePicture();
        }
      },
    },
    targetGroupId: {
      handler(newGroupId) {
        if (newGroupId) {
          this.fetchProfilePicture();
        }
      },
    },
  },
  methods: {
    fetchProfilePicture() {
      if (this.uuid && this.targetGroupId && !this.pictureUrl) {
        this.groupsStore.downloadGroupMemberProfilePictureData({
          uuid: this.uuid,
          groupId: this.targetGroupId,
          format: ImageSizes.Thumb,
        });
      }
    },
    openProfile() {
      if (this.uuid) {
        this.openMemberProfile(this.uuid);
      }
    },
  },
};
</script>
<style scoped>
.opacity-enter-active {
  transition: opacity 0.5s ease;
}

.opacity-leave-active {
  position: absolute;
  left: 0;
  transition: opacity 0.5s ease;
}
.opacity-enter, .opacity-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
